import { createContext, useContext } from 'react';

import type { PendingAction } from './pendingAction';

export interface AuthDialogContextValue {
  /**
   * Открыть окно входа. Переданное действие выполнится автоматически после
   * успешной авторизации (MVP_PRD §8).
   */
  requestAuth: (pending?: Omit<PendingAction, 'returnUrl'> & { returnUrl?: string }) => void;
  closeAuth: () => void;
  isOpen: boolean;
}

export const AuthDialogContext = createContext<AuthDialogContextValue | null>(null);

export function useAuthDialog(): AuthDialogContextValue {
  const context = useContext(AuthDialogContext);
  if (!context) {
    throw new Error('useAuthDialog must be used inside <AuthProvider>');
  }
  return context;
}
